"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFilter = exports.getCellValue = void 0;
const _ = __importStar(require("lodash"));
const peg = __importStar(require("pegjs"));
const helpers_1 = require("./helpers");
const parseISO_1 = __importDefault(require("date-fns/parseISO"));
const NULL_CLAUSES = ['ures', 'none', 'nil', 'null'], TRUTHY_CLAUSES = ['yes', 'igen', 'true', '1'], FALSY_CLAUSES = ['no', 'nem', 'false', '0'];
const NumParser = peg.generate(`
start = NumGe
  / NumLe
  / NumG
  / NumL
  / NumRange
  / NumEq
  / NumNotEq


NumNotEq
  = left:Number "!=" right:Number { return left !== right; }

NumEq
  = left:Number "=" right:Number { return left === right; }

NumGe
  = left:Number ">=" right:Number { return left >= right; }

NumLe
  = left:Number "<=" right:Number { return left <= right; }

NumG
  = left:Number ">" right:Number { return left > right; }

NumL
  = left:Number "<" right:Number { return left < right; }

NumRange
  = left:Number "=" min:Number "-" max:Number { return min <= left && left <= max; }


Number
  = Float / Integer

Integer
  = _ [0-9]+ { return parseInt(text(), 10); }

Float
  = _ Integer+ '.' Integer+ { return parseFloat(text()); }

// optional whitespace
_  = [ ]*

// mandatory whitespace
__ = [ ]+
`);
function getCellValue(data, column, grid) {
    const field = column.field;
    (0, helpers_1.assertNonNullish)(column.field, 'Column field is required.');
    let cellValue = data[_.toString(column.field)];
    const formatter = column.formatter;
    if (formatter && formatter.getCellValue) {
        return formatter.getCellValue(-1, -1, cellValue, column, data, grid);
    }
    if (formatter && formatter.filterFormattedData) {
        return formatter(-1, -1, cellValue, column, data, grid);
    }
    if (_.isArray(cellValue)) {
        cellValue = cellValue.join(', ');
    }
    if ((0, helpers_1.isEmpty)(cellValue)) {
        return null;
    }
    return cellValue;
}
exports.getCellValue = getCellValue;
function removeDiacritics(value) {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function evalStringMatch(input, value) {
    value = _.isNull(value) ? value : removeDiacritics(value).toLowerCase();
    input = removeDiacritics(input).toLowerCase();
    const token_0 = input[0];
    if (value === null || typeof value === 'undefined') {
        return false;
    }
    if (token_0 === '=') {
        return value === input.substr(1);
    }
    if (token_0 === '^') {
        return _.startsWith(value, input.substr(1));
    }
    if (input[input.length - 1] === '$') {
        return _.endsWith(value, input.substring(0, input.length - 1));
    }
    if (NULL_CLAUSES.indexOf(input) > -1) {
        return value === null || value === '';
    }
    if (TRUTHY_CLAUSES.indexOf(input) > -1) {
        return value === 'true';
    }
    if (FALSY_CLAUSES.indexOf(input) > -1) {
        return value === 'false';
    }
    return value.indexOf(input) > -1;
}
function stringMatches(input, value) {
    const isNot = input && input[0] === '!', result = evalStringMatch(isNot ? input.substring(1) : input, value);
    return isNot ? !result : result;
}
function splitAtFirstDigit(input) {
    for (let i = 0; i < input.length; i++) {
        if (input[i] >= "0" && input[i] <= "9") {
            return [input.slice(0, i), input.slice(i)];
        }
    }
    return [input, ""];
}
function matches(input, value) {
    input = input.trim();
    if (_.isDate(value)) {
        try {
            const [rel, d] = splitAtFirstDigit(input);
            const parsedInput = (0, parseISO_1.default)(d);
            if (!_.isNaN(parsedInput)) {
                input = rel + parsedInput.valueOf().toString();
                value = value.valueOf().toString();
            }
        }
        catch (error) { }
    }
    try {
        return NumParser.parse(`${value}${input}`);
    }
    catch (error) { }
    return stringMatches(input, _.isNull(value) ? null : value.toString());
}
function simpleFilterCallback(cls) {
    return function (item) {
        if (cls.filters) {
            const grid = cls.grid, columns = grid.getColumns();
            return _.every(cls.filters, (filterValue, columnId) => {
                if ((0, helpers_1.isEmpty)(filterValue)) {
                    return true;
                }
                let col = columns[grid.getColumnIndex(columnId)], value = getCellValue(item, col, cls.grid);
                return matches(filterValue, value);
            });
        }
        return true;
    };
}
class DataFilter {
    $filters;
    grid;
    callback;
    constructor(grid, filters) {
        this.grid = grid;
        this.callback = simpleFilterCallback(this);
    }
    setFilters(value) {
        this.$filters = _.reduce(value, (m, v, k) => {
            if (!(0, helpers_1.isEmpty)(v)) {
                m[k] = v;
            }
            return m;
        }, {});
    }
    get filters() {
        return this.$filters;
    }
}
exports.DataFilter = DataFilter;
//# sourceMappingURL=filters.js.map